import * as React from 'react';
import { Link } from '../../../../../common/Link';
import { ErrorWrapper } from '../ErrorWrapper';
import { pointerIcon } from '../../icons';

interface IGeoEmptyProps {
  onLinkClick(): void;
}

export const GeoEmpty = ({ onLinkClick }: IGeoEmptyProps) => {
  return (
    <ErrorWrapper icon={pointerIcon}>
      Введите <Link onClick={onLinkClick}>адрес</Link>, чтобы увидеть, на какой странице поиска будет объявление
    </ErrorWrapper>
  );
};
